<script>
	// Stores
	import PreferenceStore from '@/Stores/PreferenceStore.js';
	import ACLStore from '@/Stores/ACLStore.js';
	// Components
	import Helmet from '@/Components/Helmet.svelte';
	import Icon from '@/Components/Icon.svelte';
	import CheckBox from '@/Components/CheckBox.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';

	function playAlert() {
		let player = new Audio(`/sounds/${$PreferenceStore.app.alertSound || 'charge'}.mp3`);
		player.play();
	}
	function playNotification() {
		let player = new Audio(`/sounds/${$PreferenceStore.app.alertNotificationSound || 'glock'}.mp3`);
		player.play();
	}
	$: availableUserProfileTabs = $ACLStore && getUserProfileTabs();

	function getUserProfileTabs() {
		const availableTabs = [];
		if (ACLStore.granted('users.read')) {
			availableTabs.push({
				tab: 'profile',
				label: 'User profile'
			});
		}
		if (ACLStore.granted('bets')) {
			availableTabs.push({
				tab: 'bet-history',
				label: 'Bet History'
			});
		}
		if (ACLStore.granted('bonuses')) {
			availableTabs.push({
				tab: 'bonus-bets',
				label: 'Bonus Bets'
			});
		}
		if (ACLStore.granted('promotions')) {
			availableTabs.push({
				tab: 'promotions',
				label: 'Promotions'
			});
		}
		if (ACLStore.granted('users.login')) {
			availableTabs.push({
				tab: 'phone-bet',
				label: 'Phone Bet'
			});
		}
		if (ACLStore.granted('users.login.betback')) {
			availableTabs.push({
				tab: 'bet-back',
				label: 'Bet Back'
			});
		}
		return availableTabs;
	}
</script>

<Helmet title="Settings" />

<div>
	<div>
		<!-- Page Header -->
		<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
			<div class="flex items-center w-full">
				<h1 class="text-xl font-bold">Settings</h1>
			</div>
		</div>
		<!-- /Page Header -->
		<div class="p-2 mx-4 bg-gray-100 rounded">
			<div class="rounded">
				<div class="mb-4 md:w-1/2 text-dark-grey">
					<div class="flex items-center px-2 bg-dark-grey text-light">
						<h2 class="flex-1 py-2 text-xl italic font-sans-condensed">Sound Settings for this browser only</h2>
					</div>
					<div class="mt-2">
						<div class="grid grid-cols-2 border">
							<div class="col-start-1 px-2 py-2 text-sm font-semibold bg-grey text-light">Option</div>
							<div class="px-2 py-2 text-sm font-semibold bg-grey text-light">Value</div>
							<div class="col-start-1 px-2 py-2">Mute Bet Alert Sound</div>
							<div class="px-2 py-2">
								<CheckBox
									checked={$PreferenceStore.app.muteAlert}
									text=""
									on:change={() => PreferenceStore.updateSetting('app.muteAlert', !$PreferenceStore.app.muteAlert)}
								/>
							</div>
							<div class="flex items-center col-start-1 px-2 py-2">
								Bet Alert Sound
								<button on:click={playAlert} class="flex items-center py-0 ml-2 text-xs btn btn-primary-action">
									Test
									<Icon name="megaphone" classes="ml-2 w-4" />
								</button>
							</div>
							<div class="px-2 py-2">
								<SelectInput
									className="w-full"
									name="alertSound"
									required={true}
									bind:value={$PreferenceStore.app.alertSound}
								>
									{#each ['classic', 'charge', 'racestart', 'whistle'] as alert, index (index)}
										{#if alert === $PreferenceStore.app.alertSound}
											<option value={alert} selected>{alert}</option>
										{:else}
											<option value={alert}>{alert}</option>
										{/if}
									{/each}
								</SelectInput>
							</div>
							<div class="col-start-1 px-2 py-2">User profile initial tab</div>
							<div class="px-2 py-2">
								<SelectInput
									className="w-full"
									name="userInitialTab"
									required={true}
									bind:value={$PreferenceStore.app.userInitialTab}
								>
									{#each availableUserProfileTabs as tab, index (index)}
										{#if tab.tab === $PreferenceStore.app.userInitialTab}
											<option value={tab.tab} selected>{tab.label}</option>
										{:else}
											<option value={tab.tab}>{tab.label}</option>
										{/if}
									{/each}
								</SelectInput>
							</div>
							<div class="col-start-1 px-2 py-2">Mute New Alert Sound</div>
							<div class="px-2 py-2">
								<CheckBox
									checked={$PreferenceStore.app.alertsMuted}
									text=""
									on:change={() => PreferenceStore.updateSetting('app.alertsMuted', !$PreferenceStore.app.alertsMuted)}
								/>
							</div>
							<div class="flex items-center col-start-1 px-2 py-2">
								New Alert Sound
								<button on:click={playNotification} class="flex items-center py-0 ml-2 text-xs btn btn-primary-action">
									Test
									<Icon name="megaphone" classes="ml-2 w-4" />
								</button>
							</div>
							<div class="px-2 py-2">
								<SelectInput
									className="w-full"
									name="alertSound"
									required={true}
									bind:value={$PreferenceStore.app.alertNotificationSound}
								>
									{#each ['strange', 'achive', 'chong', 'ding', 'game', 'glock', 'odd', 'pop'] as alert, index (index)}
										{#if alert === $PreferenceStore.app.alertNotificationSound}
											<option value={alert} selected>{alert}</option>
										{:else}
											<option value={alert}>{alert}</option>
										{/if}
									{/each}
								</SelectInput>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
